export const SENSOR_SESSION_LIST_STATUS = Object.freeze({
    IDLE: 'idle',
    LOADING: 'loading',
    LOADED: 'loaded',
    FAILED: 'failed',
    BLOCKED: 'blocked',
})
